export const theme = {
    mainColor1: '#0C7477',
    borderColor: '#e0e0e0',
    inputPlaceholderColor: '#999',
    inputDefaultColor: '#555',
    inputColor: '#111',
};